/* greys */
export const giphyBlack = '#121212'
export const giphyDarkestGrey = '#212121'
export const giphyDarkGrey = '#2e2e2e'
export const giphyDarkCharcoal = '#3e3e3e'
export const giphyCharcoal = '#4a4a4a'
export const giphyLightCharcoal = '#5c5c5c'
export const giphyLightGrey = '#a6a6a6'
export const giphyLightestGrey = '#d8d8d8'
export const giphyWhite = '#ffffff'
/* primary */
export const giphyBlue = '#00ccff'
export const giphyGreen = '#00ff99'
export const giphyPurple = '#9933ff'
export const giphyRed = '#ff6666'
export const giphyYellow = '#fff35c'
/* secondary */
export const giphyAqua = '#00e6cc'
export const giphyLightBlue = '#3191ff'
export const giphyIndigo = '#6157ff'
export const giphyPink = '#e646b6'
/* social */
export const facebookColor = '#3894fc'
export const twitterColor = '#00ccff'
export const pinterestColor = '#e54cb5'
export const tumblrColor = '#529ecc'
export const instagramColor = '#c23c8d'
export const redditColor = '#fc6669'
export const smsColor = '#00ff99'
/* functional */
export const errorColor = giphyRed
export const deleteColor = giphyRed
export const primaryCTA = giphyIndigo
export const primaryCTADisabled = '#241F74'
export const secondaryCTA = giphyCharcoal
export const dimColor = `rgba(0, 0, 0, 0.8)`
export const gifOverlayColor = `rgba(0, 0, 0, 0.4)`
/* code-example */
export const codeCopyTextColor = '#5C5C5C'
/* sdk-features */
export const featureBackgroundColor = '#F8F8F8'
